import { generateColors } from "@mantine/colors-generator";
import type { MantineColorsTuple } from "@mantine/core";

// Build a Mantine color ramp from a single brand color, pinning shade 6 to the
// exact input. Mantine resolves --mantine-primary-color-filled to shade 6 in
// light mode, so pinning ensures filled elements (buttons, active nav borders)
// render the exact picked color rather than the generator's computed shade.
export function brandColorTuple(base: string): MantineColorsTuple {
  const [c0, c1, c2, c3, c4, c5, , c7, c8, c9] = generateColors(base) as MantineColorsTuple;
  return [c0, c1, c2, c3, c4, c5, base, c7, c8, c9];
}
